"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var defaultStyle = {
  backgroundColor: 'rgba(0, 244, 0, 0.6)',
  color: 'lightgrey',
  display: 'block',
  fontFamily: 'sans-serif',
  padding: '0.5em',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 10
};
exports.initialTooltipState = {
  show: true,
  timer: undefined
};

var ChellTooltip =
/** @class */
function (_super) {
  __extends(ChellTooltip, _super);

  function ChellTooltip(props) {
    var _this = _super.call(this, props) || this;

    _this.state = exports.initialTooltipState;
    return _this;
  }

  ChellTooltip.prototype.componentDidUpdate = function (nextProps) {
    var _this = this;

    var _a = nextProps.timeout,
        timeout = _a === void 0 ? 0 : _a;

    if (!this.state.timer && timeout > 0) {
      var timer = setTimeout(function () {
        _this.setState({
          show: false
        });
      }, timeout);
      this.setState({
        timer: timer
      });
    }
  };

  ChellTooltip.prototype.componentWillUnmount = function () {
    var timer = this.state.timer;

    if (timer) {
      clearTimeout(timer);
    }
  };

  ChellTooltip.prototype.render = function () {
    var _a = this.props,
        message = _a.message,
        _b = _a.style,
        style = _b === void 0 ? defaultStyle : _b;
    var show = this.state.show;
    return show && React.createElement("div", {
      style: style,
      className: "ChellTooltip"
    }, message);
  };

  return ChellTooltip;
}(React.Component);

exports.ChellTooltip = ChellTooltip;